/* LovePTCGevoL — require the cancellation-policy checkbox before checkout, and record the
   agreement (with timestamp) as a cart attribute so it shows up under "Additional details"
   on the order in the Shopify admin.
   Injects a checkbox above the checkout button (cart page AND cart drawer) and blocks the
   native checkout button plus the accelerated wallet buttons until it is ticked.
   Re-runs on cart re-render (Horizon morphs the cart DOM). */
(function () {
  var POLICY_URL = '/policies/refund-policy';
  var TEXT_HEAD =
    'By placing this order, you agree to our cancellation policy. A 15% fee applies to all canceled orders, including pre-orders. Cancellations must be requested before shipping. See our ';
  var LINK_LABEL = 'Cancellation Policy';
  var TEXT_TAIL = ' for full details.';
  var WARN = 'Please agree to the cancellation policy before checking out.';
  var ATTR = 'Cancellation Policy';

  /* Save/clear the agreement as a cart attribute (shows in the order's Additional details). */
  function record(agreed) {
    var attrs = {};
    attrs[ATTR] = agreed ? 'Agreed to the Cancellation Policy on ' + new Date().toString() : '';
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  function build(ctas) {
    var wrap = document.createElement('div');
    wrap.className = 'lp-agree';

    var label = document.createElement('label');
    label.className = 'lp-agree__label';

    var box = document.createElement('input');
    box.type = 'checkbox';
    box.className = 'lp-agree__box';

    var span = document.createElement('span');
    span.className = 'lp-agree__text';
    span.appendChild(document.createTextNode(TEXT_HEAD));
    var a = document.createElement('a');
    a.href = POLICY_URL;
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = LINK_LABEL;
    span.appendChild(a);
    span.appendChild(document.createTextNode(TEXT_TAIL));

    label.appendChild(box);
    label.appendChild(span);
    wrap.appendChild(label);

    var err = document.createElement('div');
    err.className = 'lp-agree__error';
    err.hidden = true;
    err.setAttribute('role', 'alert');
    err.textContent = WARN;
    wrap.appendChild(err);

    ctas.parentNode.insertBefore(wrap, ctas);
    return { wrap: wrap, box: box, err: err };
  }

  function apply(ctas) {
    if (!ctas || ctas.__lpAgree) return;
    ctas.__lpAgree = true;

    var parts = build(ctas);
    var box = parts.box;
    var err = parts.err;

    function ok() { return box.checked; }

    function sync() {
      var btn = ctas.querySelector('.cart__checkout-button');
      if (btn) {
        if (ok()) { btn.removeAttribute('aria-disabled'); btn.classList.remove('lp-blocked'); }
        else { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('lp-blocked'); }
      }
      ctas.classList.toggle('lp-agree-ok', ok());
      if (ok()) err.hidden = true;
    }

    box.addEventListener('change', function () {
      sync();
      record(box.checked);
      /* keep every checkbox on the page (cart page + drawer) in sync */
      var all = document.querySelectorAll('.lp-agree__box');
      for (var i = 0; i < all.length; i++) {
        if (all[i] !== box && all[i].checked !== box.checked) {
          all[i].checked = box.checked;
          all[i].dispatchEvent(new Event('lp-sync'));
        }
      }
    });
    box.addEventListener('lp-sync', sync);
    sync();

    ctas.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!(t && t.closest)) return;
        var hitCheckout = t.closest('.cart__checkout-button');
        var hitWallet = t.closest('.additional-checkout-buttons');
        if (!hitCheckout && !hitWallet) return;
        if (ok()) return;
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        err.hidden = false;
        parts.wrap.classList.add('lp-agree--shake');
        setTimeout(function () { parts.wrap.classList.remove('lp-agree--shake'); }, 500);
        try { box.focus({ preventScroll: false }); } catch (x) {}
      },
      true
    );

    var form = document.getElementById('cart-form');
    if (form && !form.__lpAgreeBound) {
      form.__lpAgreeBound = true;
      form.addEventListener(
        'submit',
        function (e) {
          var live = document.querySelector('.lp-agree__box');
          if (live && !live.checked) {
            e.preventDefault();
            e.stopPropagation();
            if (e.stopImmediatePropagation) e.stopImmediatePropagation();
            var liveErr = document.querySelector('.lp-agree__error');
            if (liveErr) liveErr.hidden = false;
          }
        },
        true
      );
    }
  }

  function scan() {
    var all = document.querySelectorAll('.cart__ctas');
    for (var i = 0; i < all.length; i++) apply(all[i]);
  }

  function boot() {
    /* A fresh cart should never carry a stale agreement from a previous order. */
    scan();
    var mo = new MutationObserver(function () { scan(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', scan);
})();
